//
// Module for the Death Setup wizard's Initiate step
//
rs.module("participant/benefit/setup/death/wizard/initiatestep",

    [
        "controls/components/event-banner",
        "common/select-helper"
    ],

    function (eventBanner, selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls, availableBenefitsBySourceBenefit) {

            // Get the wizard's next button
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var initiateOnlyCheckBox = stepContainer.js(jsSelectors.initiateOnlyCheckBox, { required: false });
            var sourceBenefitSelect = stepContainer.js(jsSelectors.sourceBenefitSelect, { required: false });
            var benefitTypeSelect = stepContainer.js(jsSelectors.benefitTypeSelect, { required: false });
            var recipientsContainer = stepContainer.js(jsSelectors.recipientsContainer, { required: false });
            var recipientsGridContainer = stepContainer.js(jsSelectors.recipientsGridContainer, { required: false });

            // get a select helper to populate benefit types
            var benefitTypeSelectHelper = null;
            if (benefitTypeSelect) {
                benefitTypeSelectHelper = selectHelper.getHelper(benefitTypeSelect);
            }

            // handle source benefit change
            sourceBenefitSelect.change(function () {
                var benefitTypes = availableBenefitsBySourceBenefit[sourceBenefitSelect.val()];
                benefitTypeSelectHelper.replaceOptions(benefitTypes, { withBlank: true });
                benefitTypeSelectHelper.setValue(null);
            });

            // On initialize of page, appropriately set wizard's next button text (Next or Finish)
            setWizardNextButtonText();

            // Hookup benefitTypeSelect change event
            benefitTypeSelect.change(benefitTypeChange);

            // Conditionally set display of Wizard's next button text (Next or Finish) based on InitiateOnlyCheckBox
            function setWizardNextButtonText() {

                // Get the Next button's HTML (contains text and spinner icon)
                var buttonHtml = wizardNextButton.html();

                // Conditionally update text portion of button's HTML based on initiateOnlyCheckBox
                if (initiateOnlyCheckBox.is(":checked")) {
                    wizardNextButton.html(buttonHtml.replace('Next', 'Finish'));
                }
                else {
                    wizardNextButton.html(buttonHtml.replace('Finish', 'Next'));
                }
            }

            // Handle initiateOnlyCheckBox change
            initiateOnlyCheckBox.change(function () {

                // Set wizard's next button text (Next or Finish)
                setWizardNextButtonText();
            });

            // Benefit Type change event
            function benefitTypeChange() {

                eventBanner.removeAllMessages();

                // Get selected Benefit Type
                var selectedBenefitType = benefitTypeSelect.val();

                // Get selected Source Benefit
                var selectedSourceBenefitKey = sourceBenefitSelect.val();

                $.get(backendUrls.getRecipientsGrid,
                    {
                        benefitType: selectedBenefitType,
                        sourceBenefitKey: selectedSourceBenefitKey
                    })
                    .done(function (html) {
                        recipientsGridContainer.html(html);
                        recipientsContainer.show();
                    })
                    .fail(function () {
                        recipientsContainer.hide();
                    });         
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);